module.exports = __webpack_public_path__ + "static/media/pres59.5689116c.png";